import React from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import { useNavigate } from 'react-router-dom';
import ContactUs from './ContactUs';

export const Connect = () => {
  const navigate = useNavigate();
  return (
    <EmployerLayout>
      <div className="flex flex-col w-full">
        <ContactUs />
      </div>
    </EmployerLayout>
  );
};
